import UIDs from "../../../UIDs";
import _ from "lodash";
import * as Helper from "../../../utils/Helper";

/**
 * Created by JIA on 2022/1/19.
 */
const i18nKey = UIDs.components.customModule.speechRecognition;
const AzureEnums = {
    RecognitionStatus: {
        Success: "Success",
        NoMatch: "NoMatch",
        InitialSilenceTimeout: "InitialSilenceTimeout",
        BabbleTimeout: "BabbleTimeout",
        Error: "Error",
    },
    WordErrorType: {
        None: "None",
        Omission: "Omission",
        Insertion: "Insertion",
        Mispronunciation: "Mispronunciation",
    },
};

const reviewServiceTypeEnum = {
    Azure: 0, //微软语音评测, 不可用
    XunFei: 1, //讯飞语音评测
    SingSound: 2, //先声语音评测
};
const recognizeServiceTypeEnum = {
    XunFeiASR: 0, //讯飞语音识别, 无时长限制
    XunFeiIAT: 1, //讯飞语音识别, 最长60s
    AliYunIAT: 2, //阿里云语音识别, 最长60s
    AliYunIntIAT: 3, //阿里云国际语音识别, 最长60s
    AzureIAT: 4, //Azure语音识别, 最长60s, 美国服务器
};

const isBlankString = (s) => {
    return _.isString(s) ? s.length === 0 || !s.trim() : _.isEmpty(s);
};

const isCNChar = (char) => {
    return /[\u4E00-\u9FFF]/gi.test(char);
};

/**
 * 判断是否为儿化音case.
 *  判断条件, 后字为 儿  并且拼音为空(空格) 前字拼音形式为 hua1r 这种最后一个字母为r前为正常拼音
 * @param char1
 * @param char2
 * @param syllable1
 * @param syllable2
 * @returns {boolean}
 * @constructor
 */
const IsTheERCase = (char1, char2, syllable1, syllable2) => {
    if (char2 === "儿" && isCNChar(char1)) {
        if (isBlankString(syllable2)) {
            if (_.endsWith(syllable1, "r")) {
                //我们认为服务器传过来的拼音是合法的,所以这里只检查拼音最后一个字母是否为r
                return true;
            }
        }
    }

    return false;
};

/**
 * 将拼音分割为声母和韵母, 支持传入空格分隔的多个拼音
 * @param pinyinStr
 * @returns {{initial: [], initialStr: string, final: [], finalStr: string}}
 */
const splitPinyinToInitialAndFinal = (pinyinStr) => {
    if (!pinyinStr) {
        return {
            finalStr: "", // 韵母
            final: "", // 韵母
            initialStr: "", // 韵母
            initial: "", // 韵母
        };
    }
    const INITIAL_LIST = ["zh", "ch", "sh", "z", "c", "s", "b", "p", "m", "f", "d", "t", "n", "l", "g", "k", "h", "j", "q", "x", "r", "y", "w", ""];
    const pinyin_arr = pinyinStr.split(" ");
    const initial_arr = [];
    const final_arr = [];
    for (let _pinyin of pinyin_arr) {
        for (let _initial of INITIAL_LIST) {
            if (_pinyin.startsWith(_initial)) {
                const _final = _pinyin.slice(_initial.length);
                initial_arr.push(_initial);
                final_arr.push(_final);
                break;
            }
        }
    }
    return {
        finalStr: final_arr.join(" "), // 韵母
        final: final_arr, // 韵母
        initialStr: initial_arr.join(" "), // 声母
        initial: initial_arr, // 声母
    };
};

const buildZeroReviewResult = (chars, syllables) => {
    chars = _.filter(Array.from(chars), (s) => !Helper.isPunctuation(s));
    return {
        passed: false,
        resultWordArray: _.cloneDeep(chars),
        referenceTextWordArray: _.cloneDeep(chars),
        pronScore: 0,
        accuracyScore: 0,
        fluencyScore: 0,
        completionScore: 0,
        wordResultArray: _.map(chars, (iChar, index) => {
            return {
                word: iChar,
                pronScore: 0,
                accuracyScore: 0,
                errorType: "None",
                flag: false,
                phonemes: syllables && syllables.length > index ? syllables[index] : "",
                syllables: [
                    {
                        content: "",
                        isYun: "0",
                        dpMessage: "0",
                        flag: false,
                        pErrMsg: "1",
                    },
                    {
                        content: "",
                        isYun: "1",
                        dpMessage: "0",
                        flag: false,
                        pErrMsg: "1",
                    },
                ],
            };
        }),
        notPassedWordIndexDic: {},
        rawResult: "",
        parsedRootEle: null,
        is_rejected: false,
        toneScore: 0,
        totalScore: 0,
        passedWordCount: 0,
        wholeWordCount: chars.length,
    };
};

const buildZeroReviewResultForEn = (words, syllables) => {
    words = _.split(words, " ");
    return {
        passed: false,
        resultWordArray: _.cloneDeep(words),
        referenceTextWordArray: _.cloneDeep(words),
        pronScore: 0,
        accuracyScore: 0,
        fluencyScore: 0,
        completionScore: 0,
        wordResultArray: _.map(words, (iChar, index) => {
            return {
                word: iChar,
                pronScore: 0,
                accuracyScore: 0,
                errorType: "None",
                flag: false,
                phonemes: syllables && syllables.length > index ? syllables[index] : "",
                syllables: [
                    {
                        content: "",
                        isYun: "0",
                        dpMessage: "0",
                        flag: false,
                        pErrMsg: "1",
                    },
                    {
                        content: "",
                        isYun: "1",
                        dpMessage: "0",
                        flag: false,
                        pErrMsg: "1",
                    },
                ],
            };
        }),
        notPassedWordIndexDic: {},
        rawResult: "",
        parsedRootEle: null,
        is_rejected: false,
        toneScore: 0,
        totalScore: 0,
        passedWordCount: 0,
        wholeWordCount: words.length,
    };
};

export { i18nKey, AzureEnums, recognizeServiceTypeEnum, reviewServiceTypeEnum, IsTheERCase, splitPinyinToInitialAndFinal, buildZeroReviewResult, buildZeroReviewResultForEn };
